// src/graphql/queries/storageQueries.js

export const getDocumentStorageStats = () => `query GetDocumentStorageStats {
    adminDocumentStorageStats {
        totalDocuments
        totalSizeBytes
        documentsWithPDF
        documentsWithExtractedText
        documentsByType {
            fileType
            count
            totalSizeBytes
        }
        evidenceCacheCount
        evidenceCacheSizeBytes
    }
}`;

export const getEvidenceCacheStatus = () => `query GetEvidenceCacheStatus($documentId: String!, $assessmentId: String!) {
    adminEvidenceCacheStatus(documentId: $documentId, assessmentId: $assessmentId) {
        documentId
        assessmentId
        isCached
        generatedAt
        snippetCount
        fullPageCount
        cacheKeyPrefix
        cacheSizeBytes
    }
}`;

export const getDocumentIntegrityCheck = () => `query GetDocumentIntegrityCheck($tenderId: String, $limit: Int) {
    adminDocumentIntegrityCheck(tenderId: $tenderId, limit: $limit) {
        tenderId
        totalDocuments
        validDocuments
        missingFiles {
            documentId
            tenderId
            documentTitle
            storageKey
            issue
            details
        }
        metadataMismatches {
            documentId
            tenderId
            documentTitle
            storageKey
            issue
            details
        }
        orphanedFiles {
            storageKey
            sizeBytes
            lastModified
        }
    }
}`;
